import { UploadImageButton } from 'components/admin/shared/UploadImageButton';
import { ActionButton } from 'elements/minute/sidebar/sidebarComponents/atomic/ActionButton';
import { EUploadResolution } from 'libs/utils/logic/operations/fileOperations';
import { Localization } from 'static/localization/localization';
import styled from 'styled-components/macro';

interface Props {
    guideId: string;
    className?: string;
    value: string;
    onChange: (value: string) => void;
    onReset: () => void;
}

export const EventFormFieldImage = (props: Props) => {
    return (
        <S_EventFormFieldImage className={props.className}>
            <S_ImageRowPreview
                $url={
                    (props.value as string) ||
                    'https://dvtqxks0zalev.cloudfront.net/2684e333-e85e-472e-8d94-8d1d8335f06c.png'
                }
            />
            <UploadImageButton
                resolution={EUploadResolution.MEDIUM}
                worldMapId={'worldMapId'}
                onUploaded={(url) => {
                    props.onChange(url);
                }}
            />
            {props.value && (
                <ActionButton
                    text={Localization.DELETE}
                    onClick={() => {
                        props.onReset();
                    }}
                />
            )}
        </S_EventFormFieldImage>
    );
};

const S_EventFormFieldImage = styled.div`
    width: 100%;
    padding: 0px 20px 0 0;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    gap: 20px;
`;

const S_ImageRowPreview = styled.div<{ $url: string }>`
    background-image: url(${(props) => props.$url});
    background-size: cover;
    background-position: center;
    width: 100px;
    height: 100px;
    border-radius: 27px;
    border: 2px solid #fff;
`;
